import { DatePipe, NgIf } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { NbButtonModule, NbDialogService } from '@nebular/theme';
import { BehaviorSubject } from 'rxjs';
import { WebSocketResults } from '../../../../core/services/web-socket.service';
import { CampaignTerminateModalComponent } from '../campaign-terminate-modal/campaign-terminate-modal.component';

@Component({
  selector: 'app-campaign-websocket-window',
  templateUrl: './campaign-websocket-window.component.html',
  styleUrls: ['./campaign-websocket-window.component.scss'],
  imports: [NgIf, DatePipe, NbButtonModule]
})
export class CampaignWebsocketWindowComponent implements OnInit {
  @Input() results$!: BehaviorSubject<WebSocketResults>;

  public results?: WebSocketResults;
  public campaign_id?: string;

  constructor(private dialogService: NbDialogService) {}

  public ngOnInit() {
    this.results$.subscribe((data) => (this.results = data));
  }

  public stop() {
    this.dialogService.open(CampaignTerminateModalComponent, {
      closeOnEsc: false,
      closeOnBackdropClick: false,
      context: { campaign_id: this.campaign_id, batch_job_id: this.results?.job_id }
    });
  }
}
